import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';

$('.popup-form--catalog-faq').submit(function (e) {
    e.preventDefault();
    const form = $(this);
    const submitButton = form.find('button[type="submit"]');

    // Проверяем состояние кнопки отправки формы
    if (form.data('submitting')) {
        return; // Если форма уже отправляется, прерываем выполнение
    }

    // Устанавливаем состояние отправки формы
    form.data('submitting', true);

    // Блокируем кнопку отправки и изменяем текст
    submitButton.prop('disabled', true).text('Отправка...');

    // Добавляем задержку в 2 секунды перед отправкой
    setTimeout(() => {
        Api.post('/api/catalog/faq/add/', form.serializeObject())
            .then(() => {
                Popup.hide('catalog-faq');
                Popup.notify('Ваш вопрос успешно отправлен');

                form[0].reset();

                // Сбрасываем состояние отправки формы
                form.data('submitting', false);

                // Разблокируем кнопку отправки и восстанавливаем текст
                submitButton.prop('disabled', false).text('Отправить');
            })
            .catch(() => {
                // Обработка ошибки, если не удалось отправить форму

                // Сбрасываем состояние отправки формы
                form.data('submitting', false);

                // Разблокируем кнопку отправки и восстанавливаем текст
                submitButton.prop('disabled', false).text('Отправить');
            });
    }, 2000); // Задержка в 2 секунды перед отправкой
});
